(function () {
  'use strict';

  var replacements = [
    ['Widenacherstrasse 6', 'Rümlangerstrasse 19'],
    ['Widenacherstrasse\u00a06', 'Rümlangerstrasse 19']
  ];

  function replaceString(value) {
    if (!value || value.indexOf('Widenacherstrasse') === -1) return value;
    replacements.forEach(function (pair) {
      value = value.split(pair[0]).join(pair[1]);
    });
    return value;
  }

  function replaceInRoot(root) {
    if (!root) return;

    var walker = document.createTreeWalker(
      root,
      NodeFilter.SHOW_TEXT,
      {
        acceptNode: function (node) {
          var parent = node.parentNode;
          if (!parent || /^(SCRIPT|STYLE|NOSCRIPT|TEXTAREA)$/i.test(parent.nodeName)) {
            return NodeFilter.FILTER_REJECT;
          }
          return node.nodeValue && node.nodeValue.indexOf('Widenacherstrasse') !== -1
            ? NodeFilter.FILTER_ACCEPT
            : NodeFilter.FILTER_REJECT;
        }
      }
    );

    var nodes = [];
    while (walker.nextNode()) nodes.push(walker.currentNode);
    nodes.forEach(function (node) {
      node.nodeValue = replaceString(node.nodeValue);
    });

    if (root.querySelectorAll) {
      root.querySelectorAll('[title], [aria-label]').forEach(function (el) {
        ['title', 'aria-label'].forEach(function (attr) {
          if (el.hasAttribute(attr)) {
            var current = el.getAttribute(attr);
            var updated = replaceString(current);
            if (updated !== current) el.setAttribute(attr, updated);
          }
        });
      });
    }
  }

  function run() {
    replaceInRoot(document.body);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run, { once: true });
  } else {
    run();
  }

  document.addEventListener('shopify:section:load', function (event) {
    replaceInRoot(event.target);
  });
})();
